import React, { useContext } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import SpinContext from '../../store/spin-context';

function GoLoader() {
    const spinContext = useContext(SpinContext);
    return (
        <Backdrop open={spinContext.spin} style={{ zIndex: 9999 }}>
            <CircularProgress color="primary" />
        </Backdrop>
    );
}

export default GoLoader;